import { baseUiInitialState, baseUiReducers } from '@hwm/ui-lib';
import { createSlice } from '@reduxjs/toolkit';

export const leakUiSlice = createSlice({
  name: 'leak-ui',
  initialState: baseUiInitialState,
  reducers: {
    ...baseUiReducers,
  },
});
